/**Created by JUNO PENG 1/2/2024.
 * Description:UT for AdminSystemConfigComponent
 * -----maintenance history-----
 */

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ToastService } from '../../../../widgets/toast/toast.service';
import { SystemConfigService } from '../../../../services/system-config.service';
import { SystemConfig } from './admin-system-config.model';
import { FormControl, FormGroup } from '@angular/forms';
import { NotificationOptions, NotificationStyles } from '../../../../widgets/notification/notification.model';
import { StringLiteralsPipe } from '../../../../pipes/translate.pipe';
import { AlertWindowService } from '../../../../widgets/alert-window/alert-window.service';
import { parseNumber } from 'libphonenumber-js';
@Component({
    selector: 'tam-admin-system-config',
    templateUrl: './admin-system-config.component.html',
    styleUrls: ['./admin-system-config.component.scss']
})
export class AdminSystemConfigComponent implements OnInit, OnDestroy {
    //#region public properties
    systemConfigProperties: SystemConfig;

    systemConfigForm = new FormGroup({
        richClientTimeoutMinutes: new FormControl(''),
        webClientTimeoutMinutes: new FormControl(''),

        openWireHost: new FormControl(''),
        openWirePort: new FormControl(''),
        stompPort: new FormControl(''),

        webSocketPort: new FormControl(''),
        webSocketProtocol: new FormControl(''),

        tokenInvalidInterval: new FormControl(''),
        tokenPluginInvalidInterval: new FormControl(''),

        tokenMobileInvalidInterval: new FormControl(''),
        tamaleProxyURL: new FormControl(''),

        enableSSO: new FormControl(false),
        tamaleIdpURL: new FormControl(''),
        proxyTamaleIdpURL: new FormControl(''),
        tamaleIdpHomeURL: new FormControl(''),
        identityProviderIssuer: new FormControl(''),
        certificate: new FormControl(''),
        proxyIdentityProviderIssuer: new FormControl(''),
        proxyCertificate: new FormControl(''),

        contentDeletionWindow: new FormControl(''),
        noteDeletionWindow: new FormControl(''),
        commentDeletionWindow: new FormControl(''),
        filePurgeProtectionWindow: new FormControl(''),
        maxRange: new FormControl(''),
        blurbLength: new FormControl(''),
        showGoToAssist: new FormControl(false),
        showFullOffline: new FormControl(false),
        clientPasswordManagement: new FormControl(false),
        autoLoginAllowed: new FormControl(false),
        showTamaleWebLink: new FormControl(false),
        tssTickerFormatTypeOverride: new FormControl({}),
        tssRegionTypeOverride: new FormControl({}),
        shortNameFormat: new FormControl(''),

        notificationRefreshMaxSize: new FormControl(''),
        notificationRefreshMessageSize: new FormControl(''),
        maxContentCacheSize: new FormControl(''),

        newsNotificationDeletionWindow: new FormControl(''),
        noteNotificationDeletionWindow: new FormControl(''),
        blastEmailNotificationDeletionWindow: new FormControl(''),
        maxNotificationCacheFileSize: new FormControl(''),

        maxSearchHits: new FormControl(''),
        maxClauseCount: new FormControl(''),
        sortResultsByDate: new FormControl(false),

        nagiosHostname: new FormControl(''),
        nagiosCmdFile: new FormControl(''),

        primaryContactName: new FormControl(''),
        primaryContactEmail: new FormControl(''),
        primaryContactMobile: new FormControl(''),
        primaryContactDesk: new FormControl(''),
        secondaryContactName: new FormControl(''),
        secondaryContactEmail: new FormControl(''),
        secondaryContactMobile: new FormControl(''),
        secondaryContactDesk: new FormControl(''),
        generalPhone: new FormControl(''),
        generalEmail: new FormControl(''),
        copyNumber: new FormControl(''),
    });

    isLoadingSubmit = false;
    isChanged = false;

    protocol_types = ['wss', 'ws'];
    characters_numbers = ['128', '256', '512', '1024'];
    ticker_Formats = ['COUNTRY ONLY US MARKET', 'COUNTRY ONLY'];
    preferred_Regions = ['United States', 'European', 'Asian'];
    shortname_Formats = ['YAHOO', 'BLOOMBERG', 'REUTERS', 'MORGAN STANLEY', 'TAMALE', 'NONE SPECIFIED'];

    get richClientTimeoutMinutes() {
        return this.systemConfigForm.get('richClientTimeoutMinutes');
    }

    get webClientTimeoutMinutes() {
        return this.systemConfigForm.get('webClientTimeoutMinutes');
    }

    get openWireHost() {
        return this.systemConfigForm.get('openWireHost');
    }

    get openWirePort() {
        return this.systemConfigForm.get('openWirePort');
    }

    get stompPort() {
        return this.systemConfigForm.get('stompPort');
    }

    get webSocketPort() {
        return this.systemConfigForm.get('webSocketPort');
    }

    get webSocketProtocol() {
        return this.systemConfigForm.get('webSocketProtocol');
    }

    get tokenInvalidInterval() {
        return this.systemConfigForm.get('tokenInvalidInterval');
    }

    get tokenPluginInvalidInterval() {
        return this.systemConfigForm.get('tokenPluginInvalidInterval');
    }

    get tokenMobileInvalidInterval() {
        return this.systemConfigForm.get('tokenMobileInvalidInterval');
    }

    get tamaleProxyURL() {
        return this.systemConfigForm.get('tamaleProxyURL');
    }

    get enableSSO() {
        return this.systemConfigForm.get('enableSSO');
    }

    get tamaleIdpURL() {
        return this.systemConfigForm.get('tamaleIdpURL');
    }

    get proxyTamaleIdpURL() {
        return this.systemConfigForm.get('proxyTamaleIdpURL');
    }

    get tamaleIdpHomeURL() {
        return this.systemConfigForm.get('tamaleIdpHomeURL');
    }

    get identityProviderIssuer() {
        return this.systemConfigForm.get('identityProviderIssuer');
    }

    get certificate() {
        return this.systemConfigForm.get('certificate');
    }

    get proxyIdentityProviderIssuer() {
        return this.systemConfigForm.get('proxyIdentityProviderIssuer');
    }
    get proxyCertificate() {
        return this.systemConfigForm.get('proxyCertificate');
    }

    get contentDeletionWindow() {
        return this.systemConfigForm.get('contentDeletionWindow');
    }

    get noteDeletionWindow() {
        return this.systemConfigForm.get('noteDeletionWindow');
    }

    get commentDeletionWindow() {
        return this.systemConfigForm.get('commentDeletionWindow');
    }

    get filePurgeProtectionWindow() {
        return this.systemConfigForm.get('filePurgeProtectionWindow');
    }

    get maxRange() {
        return this.systemConfigForm.get('maxRange');
    }

    get blurbLength() {
        return this.systemConfigForm.get('blurbLength');
    }

    get showGoToAssist() {
        return this.systemConfigForm.get('showGoToAssist');
    }

    get showFullOffline() {
        return this.systemConfigForm.get('showFullOffline');
    }

    get clientPasswordManagement() {
        return this.systemConfigForm.get('clientPasswordManagement');
    }

    get autoLoginAllowed() {
        return this.systemConfigForm.get('autoLoginAllowed');
    }

    get showTamaleWebLink() {
        return this.systemConfigForm.get('showTamaleWebLink');
    }

    get tssTickerFormatTypeOverride() {
        return this.systemConfigForm.get('tssTickerFormatTypeOverride');
    }

    get tssRegionTypeOverride() {
        return this.systemConfigForm.get('tssRegionTypeOverride');
    }

    get shortNameFormat() {
        return this.systemConfigForm.get('shortNameFormat');
    }

    get notificationRefreshMaxSize() {
        return this.systemConfigForm.get('notificationRefreshMaxSize');
    }

    get notificationRefreshMessageSize() {
        return this.systemConfigForm.get('notificationRefreshMessageSize');
    }

    get maxContentCacheSize() {
        return this.systemConfigForm.get('maxContentCacheSize');
    }

    get newsNotificationDeletionWindow() {
        return this.systemConfigForm.get('newsNotificationDeletionWindow');
    }

    get noteNotificationDeletionWindow() {
        return this.systemConfigForm.get('noteNotificationDeletionWindow');
    }

    get blastEmailNotificationDeletionWindow() {
        return this.systemConfigForm.get('blastEmailNotificationDeletionWindow');
    }

    get maxNotificationCacheFileSize() {
        return this.systemConfigForm.get('maxNotificationCacheFileSize');
    }

    get maxSearchHits() {
        return this.systemConfigForm.get('maxSearchHits');
    }

    get maxClauseCount() {
        return this.systemConfigForm.get('maxClauseCount');
    }

    get sortResultsByDate() {
        return this.systemConfigForm.get('sortResultsByDate');
    }

    get nagiosHostname() {
        return this.systemConfigForm.get('nagiosHostname');
    }

    get nagiosCmdFile() {
        return this.systemConfigForm.get('nagiosCmdFile');
    }

    get primaryContactName() {
        return this.systemConfigForm.get('primaryContactName');
    }
    get primaryContactEmail() {
        return this.systemConfigForm.get('primaryContactEmail');
    }
    get primaryContactMobile() {
        return this.systemConfigForm.get('primaryContactMobile');
    }
    get primaryContactDesk() {
        return this.systemConfigForm.get('primaryContactDesk');
    }
    get secondaryContactName() {
        return this.systemConfigForm.get('secondaryContactName');
    }
    get secondaryContactEmail() {
        return this.systemConfigForm.get('secondaryContactEmail');
    }
    get secondaryContactMobile() {
        return this.systemConfigForm.get('secondaryContactMobile');
    }
    get secondaryContactDesk() {
        return this.systemConfigForm.get('secondaryContactDesk');
    }
    get generalPhone() {
        return this.systemConfigForm.get('generalPhone');
    }

    get generalEmail() {
        return this.systemConfigForm.get('generalEmail');
    }
    get copyNumber() {
        return this.systemConfigForm.get('copyNumber');
    }
    //#endregion

    //#region privat properties
    private _destroySubscriptions: Array<Subscription> = [];

    // Allow input to be empty or match the email format
    private _emailReg = /^$|^(\w-*\.*)+@?(\w-?)+(\.\w{2,})+$/;

    // Allow input to be empty or match the http/https format
    private _httpReg = /^$|^(https?):\/\//i;

    // Allow input to be empty or be a positive integer
    private _interReg = /^$|^[1-9]\d*$/;
    //#endregion

    constructor(
        private _alertWindow: AlertWindowService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _systemConfigService: SystemConfigService,
        private _toastService: ToastService,
    ) { }

    ngOnInit() {
        this.tssTickerFormatTypeOverride.setValue('COUNTRY ONLY US MARKET');
        this.tssRegionTypeOverride.setValue('United States');
        this.blurbLength.setValue('128');
        this._getSystemConfigSettings();
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._destroySubscriptions = [];
    }

    clickVaild() {
        this.isChanged = true;
        this._doValidation();
        if (!this._doValidation) {
            this.isLoadingSubmit = false;
        }
    }

    clickSystemConfigSbumit() {
        this.isLoadingSubmit = true;
        if (this._doValidation()) {
            this.systemConfigProperties.tssSessionConfig.richClientTimeoutMinutes = Number(this.richClientTimeoutMinutes.value);
            this.systemConfigProperties.tssSessionConfig.webClientTimeoutMinutes = Number(this.webClientTimeoutMinutes.value);
            this.systemConfigProperties.tssMessageQueueConfig.openWireHost = this.openWireHost.value;
            this.systemConfigProperties.tssMessageQueueConfig.openWirePort = Number(this.openWirePort.value);
            this.systemConfigProperties.tssMessageQueueConfig.stompPort = Number(this.stompPort.value);
            this.systemConfigProperties.tssWebSocketConfig.webSocketPort = Number(this.webSocketPort.value);
            this.systemConfigProperties.tssWebSocketConfig.webSocketProtocol = this.webSocketProtocol.value;
            this.systemConfigProperties.tssTokenConfig.tokenInvalidInterval = parseInt(this.tokenInvalidInterval.value) * 60 * 1000;
            this.systemConfigProperties.tssTokenConfig.tokenPluginInvalidInterval = parseInt(this.tokenPluginInvalidInterval.value) * 60 * 1000;
            this.systemConfigProperties.tssTokenConfig.tokenMobileInvalidInterval = parseInt(this.tokenMobileInvalidInterval.value) * 60 * 1000;
            this.systemConfigProperties.tssNextGenConfig.tamaleProxyURL = this.tamaleProxyURL.value;
            this.systemConfigProperties.tssNextGenConfig.enableSlaask = false;
            this.systemConfigProperties.tssNextGenConfig.enableSSO = this.enableSSO.value;
            this.systemConfigProperties.tssNextGenConfig.tamaleIdpURL = this.tamaleIdpURL.value;
            this.systemConfigProperties.tssNextGenConfig.proxyTamaleIdpURL = this.proxyTamaleIdpURL.value;
            this.systemConfigProperties.tssNextGenConfig.tamaleIdpHomeURL = this.tamaleIdpHomeURL.value;
            this.systemConfigProperties.tssNextGenConfig.identityProviderIssuer = this.identityProviderIssuer.value;
            this.systemConfigProperties.tssNextGenConfig.certificate = this.certificate.value;
            this.systemConfigProperties.tssNextGenConfig.proxyIdentityProviderIssuer = this.proxyIdentityProviderIssuer.value;
            this.systemConfigProperties.tssNextGenConfig.proxyCertificate = this.proxyCertificate.value;
            this.systemConfigProperties.tssClientConfig.contentDeletionWindow = Number(this.contentDeletionWindow.value);
            this.systemConfigProperties.tssClientConfig.noteDeletionWindow = Number(this.noteDeletionWindow.value);
            this.systemConfigProperties.tssClientConfig.commentDeletionWindow = Number(this.commentDeletionWindow.value);
            this.systemConfigProperties.tssClientConfig.filePurgeProtectionWindow = Number(this.filePurgeProtectionWindow.value);
            this.systemConfigProperties.tssClientConfig.maxRange = Number(this.maxRange.value);
            this.systemConfigProperties.tssClientConfig.blurbLength = Number(this.blurbLength.value);
            this.systemConfigProperties.tssClientConfig.showGoToAssist = this.showGoToAssist.value;
            this.systemConfigProperties.tssClientConfig.showFullOffline = this.showFullOffline.value;
            this.systemConfigProperties.tssClientConfig.clientPasswordManagement = this.clientPasswordManagement.value;
            this.systemConfigProperties.tssClientConfig.autoLoginAllowed = this.autoLoginAllowed.value;
            this.systemConfigProperties.tssClientConfig.showTamaleWebLink = this.showTamaleWebLink.value;
            this.systemConfigProperties.tssClientConfig.tssTickerFormatTypeOverride = {
                type: {
                    stringValue: this.tssTickerFormatTypeOverride.value === 'COUNTRY ONLY US MARKET' ? 'COUNTRYCODEUSMARKETSUFFIX' : 'COUNTRY',
                    type: this.tssTickerFormatTypeOverride.value === 'COUNTRY ONLY US MARKET' ? 2 : 0
                }
            };
            this.systemConfigProperties.tssClientConfig.tssRegionTypeOverride = {
                type: {
                    stringValue: this.tssRegionTypeOverride.value?.toString().toUpperCase().replace(/\s*/g, ''),
                    type: this.tssRegionTypeOverride.value === 'European' ? 1 : (this.tssRegionTypeOverride.value === 'Asian' ? 2 : 0)
                }
            };
            this.systemConfigProperties.tssClientConfig.shortNameFormat = this.shortNameFormat.value;
            this.systemConfigProperties.tssCacheConfig.notificationRefreshMaxSize = Number(this.notificationRefreshMaxSize.value);
            this.systemConfigProperties.tssCacheConfig.notificationRefreshMessageSize = Number(this.notificationRefreshMessageSize.value);
            this.systemConfigProperties.tssCacheConfig.maxContentCacheSize = Number(this.maxContentCacheSize.value);
            this.systemConfigProperties.tssCacheConfig.newsNotificationDeletionWindow = Number(this.newsNotificationDeletionWindow.value);
            this.systemConfigProperties.tssCacheConfig.noteNotificationDeletionWindow = Number(this.noteNotificationDeletionWindow.value);
            this.systemConfigProperties.tssCacheConfig.blastEmailNotificationDeletionWindow = Number(this.blastEmailNotificationDeletionWindow.value);
            this.systemConfigProperties.tssCacheConfig.maxNotificationCacheFileSize = Number(this.maxNotificationCacheFileSize.value);
            this.systemConfigProperties.tssSearchConfig.maxSearchHits = Number(this.maxSearchHits.value);
            this.systemConfigProperties.tssSearchConfig.maxClauseCount = Number(this.maxClauseCount.value);
            this.systemConfigProperties.tssSearchConfig.sortResultsByDate = this.sortResultsByDate.value;
            this.systemConfigProperties.tssNagiosConfig.nagiosHostname = this.nagiosHostname.value;
            this.systemConfigProperties.tssNagiosConfig.nagiosCmdFile = this.nagiosCmdFile.value;
            this.systemConfigProperties.tssClientServiceConfig.primaryContactName = this.primaryContactName.value;
            this.systemConfigProperties.tssClientServiceConfig.primaryContactEmail = this.primaryContactEmail.value;
            this.systemConfigProperties.tssClientServiceConfig.primaryContactMobile = this.primaryContactMobile.value;
            this.systemConfigProperties.tssClientServiceConfig.primaryContactDesk = this.primaryContactDesk.value;
            this.systemConfigProperties.tssClientServiceConfig.secondaryContactName = this.secondaryContactName.value;
            this.systemConfigProperties.tssClientServiceConfig.secondaryContactEmail = this.secondaryContactEmail.value;
            this.systemConfigProperties.tssClientServiceConfig.secondaryContactMobile = this.secondaryContactMobile.value;
            this.systemConfigProperties.tssClientServiceConfig.secondaryContactDesk = this.secondaryContactDesk.value;
            this.systemConfigProperties.tssClientServiceConfig.generalPhone = this.generalPhone.value;
            this.systemConfigProperties.tssClientServiceConfig.generalEmail = this.generalEmail.value;
            this.systemConfigProperties.tssClientServiceConfig.copyNumber = this.copyNumber.value;
            this._setMailSettingProperties();
        } else {
            this.isLoadingSubmit = false;
        }
    }

    clickSystemStatusShut() {
        const message = `Are you sure you want to shut down?`;
        const subscription = this._alertWindow.warn(StringLiteralsPipe.translate('system.shut_down_this_computer'),
            [message], 'Shut down', 'Cancel')
            .subscribe((result: boolean) => {
                if (result) {
                    this._systemConfigService.changeSystemStatus('shutdown').pipe(take(1)).subscribe(data => {
                        if (data) {
                            this._toast(NotificationStyles.Success, StringLiteralsPipe.translate('system.shut_this_computer_successful'));
                        }
                    }, error => {
                        this._toast(NotificationStyles.Error, error.message);
                    });
                }
                subscription.unsubscribe();
            });
    }

    clickSystemStatusReboot() {
        const message = `Are you sure you want to reboot ?`;
        const subscription = this._alertWindow.warn(StringLiteralsPipe.translate('system.reboot_this_computer'),
            [message], 'Reboot', 'Cancel')
            .subscribe((result: boolean) => {
                if (result) {
                    this._systemConfigService.changeSystemStatus('reboot').pipe(take(1)).subscribe(data => {
                        if (data) {
                            this._toast(NotificationStyles.Success, StringLiteralsPipe.translate('system.reboot_this_computer_successful'));
                        }
                    }, error => {
                        this._toast(NotificationStyles.Error, error.message);
                    });
                }
                subscription.unsubscribe();
            });
    }

    refresh(): boolean {
        return true;
    }

    private _initSystemConfigData(data: SystemConfig) {
        const configMap = {
            tssSessionConfig: ['richClientTimeoutMinutes', 'webClientTimeoutMinutes'],
            tssMessageQueueConfig: ['openWireHost', 'openWirePort', 'stompPort'],
            tssWebSocketConfig: ['webSocketPort', 'webSocketProtocol'],
            tssTokenConfig: ['tokenInvalidInterval', 'tokenPluginInvalidInterval', 'tokenMobileInvalidInterval'],
            tssNextGenConfig: [
                'tamaleProxyURL', 'enableSSO', 'tamaleIdpURL', 'proxyTamaleIdpURL',
                'tamaleIdpHomeURL', 'identityProviderIssuer', 'certificate',
                'proxyIdentityProviderIssuer', 'proxyCertificate'
            ],
            tssClientConfig: [
                'contentDeletionWindow', 'noteDeletionWindow', 'commentDeletionWindow',
                'filePurgeProtectionWindow', 'maxRange', 'blurbLength', 'showGoToAssist', 'showFullOffline',
                'clientPasswordManagement', 'autoLoginAllowed', 'showTamaleWebLink',
                'tssTickerFormatTypeOverride', 'tssRegionTypeOverride', 'shortNameFormat'
            ],
            tssCacheConfig: [
                'notificationRefreshMaxSize', 'notificationRefreshMessageSize', 'maxContentCacheSize',
                'newsNotificationDeletionWindow', 'noteNotificationDeletionWindow',
                'blastEmailNotificationDeletionWindow', 'maxNotificationCacheFileSize'
            ],
            tssSearchConfig: ['maxSearchHits', 'maxClauseCount', 'sortResultsByDate'],
            tssNagiosConfig: ['nagiosHostname', 'nagiosCmdFile'],
            tssClientServiceConfig: [
                'primaryContactName', 'primaryContactEmail', 'primaryContactMobile', 'primaryContactDesk',
                'secondaryContactName', 'secondaryContactEmail', 'secondaryContactMobile', 'secondaryContactDesk',
                'generalPhone', 'generalEmail', 'copyNumber'
            ],
        };

        for (const section in configMap) {
            if (configMap.hasOwnProperty(section)) {
                const keys = configMap[section];
                keys.forEach(key => {
                    if (data[section] && data[section][key] !== undefined) {
                        if (key === 'tssTickerFormatTypeOverride') {
                            if (data[section][key]?.type?.stringValue === 'COUNTRYCODEUSMARKETSUFFIX') {
                                this[key].setValue('COUNTRY ONLY US MARKET');
                            } else {
                                this[key].setValue('COUNTRY ONLY');
                            }
                        } else if (key === 'tssRegionTypeOverride') {
                            if (data[section][key]?.type?.stringValue === 'UNITEDSTATES') {
                                this[key].setValue('United States');
                            } else if (data[section][key]?.type?.stringValue === 'EUROPEAN') {
                                this[key].setValue('European');
                            } else {
                                this[key].setValue('Asian');
                            }
                        } else if (key === 'blurbLength') {
                            this[key].setValue(data[section][key].toString());
                        } else {
                            this[key].setValue(data[section][key]);
                        }
                    }
                });
            }
        }

        this.tokenInvalidInterval.setValue(Math.floor(data.tssTokenConfig.tokenInvalidInterval / 60000).toString());
        this.tokenPluginInvalidInterval.setValue(Math.floor(data.tssTokenConfig.tokenPluginInvalidInterval / 60000).toString());
        this.tokenMobileInvalidInterval.setValue(Math.floor(data.tssTokenConfig.tokenMobileInvalidInterval / 60000).toString());
    }

    private _doValidation(): boolean {
        const fieldsToValidateByCondition = [
            this.tamaleIdpHomeURL
        ];

        const fieldsToValidate = [
            this.richClientTimeoutMinutes,
            this.webClientTimeoutMinutes,
            this.openWirePort,
            this.stompPort,
            this.webSocketPort,
            this.webSocketProtocol,
            this.tokenInvalidInterval,
            this.tokenPluginInvalidInterval,
            this.tokenMobileInvalidInterval,
            this.contentDeletionWindow,
            this.noteDeletionWindow,
            this.commentDeletionWindow,
            this.filePurgeProtectionWindow,
            this.maxRange,
            this.notificationRefreshMaxSize,
            this.notificationRefreshMessageSize,
            this.maxContentCacheSize,
            this.newsNotificationDeletionWindow,
            this.noteNotificationDeletionWindow,
            this.blastEmailNotificationDeletionWindow,
            this.maxNotificationCacheFileSize,
            this.maxSearchHits,
            this.maxClauseCount,
        ];

        if (this.enableSSO.value) {
            fieldsToValidate.push(...fieldsToValidateByCondition);
        } else {
            fieldsToValidateByCondition.forEach(field => {
                field.setErrors(null);
            });
        }

        const emailValidate = [
            this.primaryContactEmail,
            this.secondaryContactEmail,
            this.generalEmail,
        ];

        const urlValidate = [
            this.tamaleIdpURL,
            this.tamaleIdpHomeURL,
            this.identityProviderIssuer,
            this.proxyTamaleIdpURL
        ];

        const interVaildate = [
            this.blurbLength,
            this.tokenInvalidInterval,
            this.tokenPluginInvalidInterval,
            this.tokenMobileInvalidInterval,
            this.richClientTimeoutMinutes,
            this.webClientTimeoutMinutes,
            this.maxSearchHits,
            this.webSocketPort,
            this.openWirePort,
            this.stompPort,
        ];

        const minVaildate = [
            this.richClientTimeoutMinutes,
            this.webClientTimeoutMinutes,
            this.tokenInvalidInterval,
            this.tokenPluginInvalidInterval,
            this.tokenMobileInvalidInterval,
        ];

        const portVaildate = [
            this.webSocketPort,
            this.openWirePort,
            this.stompPort,
        ];

        let dataValid = true;

        fieldsToValidate.forEach(field => {
            field.setErrors(null);
            if (!field.value && parseInt(field.value) !== 0) {
                field.setErrors({ required: true });
                dataValid = false;
            }
        });

        emailValidate.forEach(field => {
            if (!this._emailReg.test(field.value)) {
                field.setErrors({ 'emailVaild': true });
                dataValid = false;
            }
        });

        urlValidate.forEach(field => {
            if (field.value) {
                if (this.enableSSO.value) {
                    if (!this._httpReg.test(field.value)) {
                        field.setErrors({ 'urlVaild': true });
                        dataValid = false;
                    }
                } else {
                    field.setErrors(null);
                }
            }
        });

        interVaildate.forEach(field => {
            if (field.value && parseInt(field.value) !== 0) {
                if (!this._interReg.test(field.value)) {
                    field.setErrors({ 'integerVaild': true });
                    dataValid = false;
                }
            }
        });

        minVaildate.forEach(field => {
            if (field.value && this._interReg.test(field.value)) {
                if (Number(field.value) < 10) {
                    field.setErrors({ 'minVaild': true });
                    dataValid = false;
                }
            }
        });

        const forbiddenPorts = [8080, 9990, 8009, 8787, 5432, 6161, 1099, 8161];
        portVaildate.forEach(field => {
            // Port validation
            if (field.value) {
                // Check if field.value is a valid number string
                if (this._interReg.test(field.value)) {
                    const portValue = parseInt(field.value);

                    if (portValue < 1024 || portValue > 65535 || forbiddenPorts.includes(portValue)) {
                        field.setErrors({ 'portVaild': true });
                        dataValid = false;
                    }
                }
            }
        });

        if (this.enableSSO.value) {
            let isVaildIdp = false;
            let isVaildProxyIdp = false;
            if (!this.tamaleIdpURL.value) {
                this.tamaleIdpURL.setErrors({ required: true });
                isVaildIdp = true;
            }
            if (!this.proxyTamaleIdpURL.value) {
                this.proxyTamaleIdpURL.setErrors({ required: true });
                isVaildProxyIdp = true;
            }
            if (isVaildIdp && isVaildProxyIdp) {
                dataValid = false;
            }
        }
        return dataValid;
    }

    private _getSystemConfigSettings() {
        this._systemConfigService.getSystemConfig().pipe(take(1)).subscribe(data => {
            this.systemConfigProperties = SystemConfig.parse(data);
            this._initSystemConfigData(this.systemConfigProperties);
        }, error => {
            this._toast(NotificationStyles.Error, error.message);
        });
    }

    private _setMailSettingProperties() {
        this._systemConfigService.putSystemConfig(this.systemConfigProperties).pipe(take(1)).subscribe(data => {
            this.isLoadingSubmit = false;
            this.isChanged = false;
            this._changeDetectorRef.detectChanges();
            if (data) {
                this._toast(NotificationStyles.Success, StringLiteralsPipe.translate('email.all_settings_are_submitted_successfully'));
            }

        }, error => {
            this.isLoadingSubmit = false;
            this._changeDetectorRef.detectChanges();
            this._toast(NotificationStyles.Error, error.message);
        });
    }

    /**
     * unify toast.
     * @param type
     * @param msg
     */
    private _toast(type: NotificationStyles, msg: string) {
        const note = new NotificationOptions();
        note.style = type;
        note.message = msg;
        this._toastService.notify(note);
        this._changeDetectorRef.detectChanges();
    }

}


